import { SortEnum } from "app/generated/graphql";
import { SortOrder } from "../../models";

export const reverseSortOrder = (sortOrder: SortOrder) =>
  sortOrder === SortEnum.Asc
    ? SortEnum.Desc
    : sortOrder === SortEnum.Desc
    ? SortEnum.Asc
    : SortEnum.Desc;
